import { createContext, useContext, useMemo, useState } from 'react';

export interface AgentChatVehicle {
  /** VIN, license plate (+ state), or YMMT — what the vetter agent runs against. */
  vehicleIdentifier: string;
  /** Display title shown in the chat context bar, e.g. "2019 Honda Civic". */
  vehicleTitle: string;
}

type AgentChatVehicleContextState = {
  vehicle: AgentChatVehicle | null;
  setVehicle: (vehicle: AgentChatVehicle | null) => void;
};

const AgentChatVehicleContext = createContext<AgentChatVehicleContextState>({
  vehicle: null,
  setVehicle: () => {},
});

export const useAgentChatVehicle = () => useContext(AgentChatVehicleContext);

interface AgentChatVehicleProviderProps {
  children: JSX.Element;
}

export const AgentChatVehicleProvider = ({
  children,
}: AgentChatVehicleProviderProps) => {
  const [vehicle, setVehicle] = useState<AgentChatVehicle | null>(null);

  const value = useMemo(() => ({ vehicle, setVehicle }), [vehicle]);

  return (
    <AgentChatVehicleContext.Provider value={value}>
      {children}
    </AgentChatVehicleContext.Provider>
  );
};
